// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__wJlBF","name":"Header_name__33aU6","birthday":"Header_birthday__3N7ZM","skeleton":"Header_skeleton__2uzrL"};